import { NgIf, NgTemplateOutlet } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
import { NgDocCodeComponent } from '@ng-doc/app/components/code';
import { NgDocCopyButtonComponent } from '@ng-doc/app/components/copy-button';
import { NgDocCodeHighlighterDirective } from '@ng-doc/app/directives/code-highlighter';
import { NgDocButtonIconComponent, NgDocTooltipDirective, NgDocSmoothResizeComponent, NgDocIconComponent, NgDocExpanderComponent } from '@ng-doc/ui-kit';
const _c0 = ["*"];
function NgDocDemoDisplayerComponent_div_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NgDocDemoDisplayerComponent_div_0_ng_doc_copy_button_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ng-doc-copy-button", 13);
    i0.ɵɵelement(1, "ng-doc-icon", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("text", ctx_r1.code);
  }
}
function NgDocDemoDisplayerComponent_div_0_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ng-doc-smooth-resize", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("trigger", ctx_r1.expandTooltipText);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.expandTooltipText, " ");
  }
}
function NgDocDemoDisplayerComponent_div_0_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ng-doc-code", 16);
    i0.ɵɵelement(1, "div", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("copyButton", false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngDocHighlighter", ctx_r1.code);
  }
}
function NgDocDemoDisplayerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "div", 6);
    i0.ɵɵtemplate(3, NgDocDemoDisplayerComponent_div_0_ng_container_3_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 8);
    i0.ɵɵtemplate(5, NgDocDemoDisplayerComponent_div_0_ng_doc_copy_button_5_Template, 2, 1, "ng-doc-copy-button", 9);
    i0.ɵɵelementStart(6, "button", 10);
    i0.ɵɵlistener("click", function NgDocDemoDisplayerComponent_div_0_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.expanded = !ctx_r1.expanded);
    });
    i0.ɵɵtemplate(7, NgDocDemoDisplayerComponent_div_0_ng_template_7_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(9, "ng-doc-icon", 11);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(10, "ng-doc-expander", 12);
    i0.ɵɵtemplate(11, NgDocDemoDisplayerComponent_div_0_ng_template_11_Template, 2, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const tooltipContent_r3 = i0.ɵɵreference(8);
    const expanderContent_r4 = i0.ɵɵreference(12);
    const ctx_r1 = i0.ɵɵnextContext();
    const demoTemplate_r5 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", demoTemplate_r5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.codeContent);
    i0.ɵɵadvance();
    i0.ɵɵproperty("rounded", false)("ngDocTooltip", tooltipContent_r3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("content", ctx_r1.codeContent ? ctx_r1.codeContent : expanderContent_r4)("expanded", ctx_r1.expanded);
  }
}
function NgDocDemoDisplayerComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
let NgDocDemoDisplayerComponent = /*#__PURE__*/(() => {
  class NgDocDemoDisplayerComponent {
    constructor() {
      this.codeContent = '';
      this.code = '';
      this.language = 'typescript';
      this.container = true;
      this.border = true;
      this.expanded = false;
    }
    get expandTooltipText() {
      return this.expanded ? 'Collapse' : 'Expand';
    }
    static {
      this.ɵfac = function NgDocDemoDisplayerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocDemoDisplayerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocDemoDisplayerComponent,
        selectors: [["ng-doc-demo-displayer"]],
        hostVars: 1,
        hostBindings: function NgDocDemoDisplayerComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("data-ng-doc-border", ctx.border);
          }
        },
        inputs: {
          codeContent: "codeContent",
          code: "code",
          language: "language",
          container: "container",
          border: "border",
          expanded: "expanded"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 3,
        vars: 2,
        consts: [["demoTemplate", ""], ["tooltipContent", ""], ["expanderContent", ""], ["class", "ng-doc-demo-wrapper", 4, "ngIf", "ngIfElse"], [1, "ng-doc-demo-wrapper"], [1, "ng-doc-demo-container"], [1, "ng-doc-demo"], [4, "ngTemplateOutlet"], [1, "ng-doc-demo-controls"], [3, "text", 4, "ngIf"], ["ng-doc-button-icon", "", 3, "click", "rounded", "ngDocTooltip"], ["icon", "code"], [3, "content", "expanded"], [3, "text"], ["icon", "copy"], [3, "trigger"], [3, "copyButton"], [3, "ngDocHighlighter"]],
        template: function NgDocDemoDisplayerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, NgDocDemoDisplayerComponent_div_0_Template, 13, 6, "div", 3)(1, NgDocDemoDisplayerComponent_ng_template_1_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const demoTemplate_r5 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.container)("ngIfElse", demoTemplate_r5);
          }
        },
        dependencies: [NgIf, NgTemplateOutlet, NgDocButtonIconComponent, NgDocTooltipDirective, NgDocSmoothResizeComponent, NgDocIconComponent, NgDocExpanderComponent, NgDocCodeComponent, NgDocCodeHighlighterDirective, NgDocCopyButtonComponent],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;overflow:hidden;--ng-doc-code-margin: 0;--ng-doc-code-border-radius: 0;--ng-doc-code-border: none}[data-ng-doc-border=true][_nghost-%COMP%]{border:var(--ng-doc-demo-displayer-border);border-radius:var(--ng-doc-demo-displayer-border-radius)}[_nghost-%COMP%]   .ng-doc-demo-wrapper[_ngcontent-%COMP%]{overflow:hidden}[_nghost-%COMP%]   .ng-doc-demo-wrapper[_ngcontent-%COMP%]   .ng-doc-demo-container[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;width:100%;padding:calc(var(--ng-doc-base-gutter) * 2);background:var(--ng-doc-demo-displayer-background, var(--ng-doc-base-0))}[_nghost-%COMP%]   .ng-doc-demo-wrapper[_ngcontent-%COMP%]   .ng-doc-demo-container[_ngcontent-%COMP%]   .ng-doc-demo[_ngcontent-%COMP%]{overflow:hidden;width:100%}[_nghost-%COMP%]   .ng-doc-demo-wrapper[_ngcontent-%COMP%]   .ng-doc-demo-container[_ngcontent-%COMP%]   .ng-doc-demo-controls[_ngcontent-%COMP%]{flex-shrink:0;margin-left:auto}[_nghost-%COMP%]   ng-doc-code[_ngcontent-%COMP%]{border-top:1px solid var(--ng-doc-border-color)}"],
        changeDetection: 0
      });
    }
  }
  return NgDocDemoDisplayerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocDemoDisplayerComponent };
